import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Segment = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="segment icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 8C5.68555 8 7.1276 6.95744 7.71648 5.48199H10C10.2761 5.48199 10.5 5.70585 10.5 5.98199V17.982C10.5 19.915 12.067 21.482 14 21.482H16.2908C16.8841 22.9479 18.3213 23.982 20 23.982C22.2091 23.982 24 22.1911 24 19.982C24 17.7729 22.2091 15.982 20 15.982C18.3213 15.982 16.8841 17.0161 16.2908 18.482H14C13.7239 18.482 13.5 18.2581 13.5 17.982V11.482H16.2908C16.8841 12.9479 18.3213 13.982 20 13.982C22.2091 13.982 24 12.1911 24 9.98199C24 7.77286 22.2091 5.98199 20 5.98199C18.3213 5.98199 16.8841 7.01608 16.2908 8.48199H13.5V5.98199C13.5 4.049 11.933 2.48199 10 2.48199H7.7019C7.10407 1.02562 5.67181 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8ZM20 10.982C20.5523 10.982 21 10.5343 21 9.98199C21 9.42971 20.5523 8.98199 20 8.98199C19.4477 8.98199 19 9.42971 19 9.98199C19 10.5343 19.4477 10.982 20 10.982ZM21 19.982C21 20.5343 20.5523 20.982 20 20.982C19.4477 20.982 19 20.5343 19 19.982C19 19.4297 19.4477 18.982 20 18.982C20.5523 18.982 21 19.4297 21 19.982Z"
    />
  </svg>
)
